export default "__VITE_ASSET__2XV76HAO__"